import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import keyboardFormMeta, { IKeyboardFormMeta } from "./KeyboardFormMeta";
import mainFormMeta, { IMainFormMeta } from "./MainFormMeta";
import printersFormMeta, { IPrintersFormMeta } from "./PrintersFormMeta";
import securityFormMeta, { ISecurityFormMeta } from "./SecurityFormMeta";
import softwareFormMeta, { ISoftwareFormMeta } from "./SoftwareFormMeta";

export interface IHardwareConfigurationFormMeta extends ISoftwareFormMeta, ISecurityFormMeta, IKeyboardFormMeta, IMainFormMeta, IPrintersFormMeta{
  
  schema: any;
}

let hardwareConfigurationFormMeta = {} as IHardwareConfigurationFormMeta;

hardwareConfigurationFormMeta = { ...hardwareConfigurationFormMeta, ...softwareFormMeta, ...securityFormMeta, ...keyboardFormMeta, ...mainFormMeta, ...printersFormMeta };

hardwareConfigurationFormMeta.schema = yup.object().shape(getValidationSchema(hardwareConfigurationFormMeta));

export default hardwareConfigurationFormMeta;